import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'

import { recommendationAccessorGetLocalizedProductName } from './recommendationAccessorGetLocalizedProductName'
import { recommendationAccessorGetLocalizedProductUrl } from './recommendationAccessorGetLocalizedProductUrl'

export const recommendationProductIsRenderable = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): boolean =>
  Boolean(
    recommendationAccessorGetLocalizedProductName({ locale, product }) &&
    recommendationAccessorGetLocalizedProductUrl({ locale, product }),
  )
